import { useState } from "react";
import { BACKEND_URL } from "../../../services/Helper";
import { toast } from "react-toastify";
import "./OfferModal.css"
import { useNavigate } from "react-router-dom";

const notifyB = (msg) => toast.success(msg);
const notifyA = (msg) => toast.error(msg);

const OfferModal = ({ menuId, onClose, onOfferAdded }) => {
    const navigate = useNavigate()
    const [offerPercentage, setOfferPercentage] = useState("");
    const [addingOfferId, setAddingOfferId] = useState(null);

    const handleAddOffer = async () => {
        try {
            setAddingOfferId(menuId)
            const token = localStorage.getItem("shoplogintoken");
            if (!token) {
                toast.error("You must be logged in to add offer on menu");
                navigate("/shoplogin");
                return;
            }
            const res = await fetch(`${BACKEND_URL}/nearbe/menu/${menuId}/addoffer`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
                body: JSON.stringify({ offerPercentage }),
            });

            const data = await res.json();
            if (!res.ok) {
                notifyA(data.message || "Failed to add offer");
                return;
            }

            notifyB("Offer added successfully");
            onOfferAdded(data.updatedMenu);
            onClose();
        } catch (error) {
            console.error(error);
            notifyA("Something went wrong");
        } finally{
            setAddingOfferId(null)
        }
    };

    return (
        <div className="offer-modal-overlay">
            <div className="offer-modal-content">
                <h2>Add Offer</h2>
                <input
                    type="number"
                    placeholder="Enter offer percentage"
                    value={offerPercentage}
                    onChange={(e) => setOfferPercentage(e.target.value)}
                />
                <div className="offermodal-actions">
                    <button className="addingoffer" onClick={handleAddOffer}>{addingOfferId === menuId ? "Adding..." : "Add Order"}</button>
                    <button className="removingoffer" onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default OfferModal;
